import React, { useState } from "react";
import api from "../../../api/api";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";

const CreateCharge = () => {
  const { register, handleSubmit, unregister, setValue } = useForm();
  const [companyType, setCompanyType] = useState(null)
  // const [registrationNature, setRegistrationNature] = useState(null)




  const handleSub = (data) => {
    api
      .post("/services/company/registration/service-charges/", data)
      .then((response) => {
        toast.success("Service Charge created Successfully");
      })
      .catch((error) => {
        toast.error("Something went wrong");
      });
  };


  return (
    <div className="px-10">
      <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
        Create Service Charge
      </h1>
      <div className="">
        <img
          src="../../images/title-border.png"
          alt=""
          className="mx-auto mt-4"
        />
      </div>

      <form onSubmit={handleSubmit(handleSub)}>
        <div className="grid grid-cols-1 md:grid-cols-2 border-2 border-primary-red ">
        <div className="p-2 md:border-r border-primary-red border-b">
          <label className="text-primary-blue ">Service Charge</label>
          <select
            className="text-primary-blue border border-primary-red  outline-none md:ml-3"
            {...register("company_type", {
              required: false,
              onChange: (e) => setCompanyType(e.target.value)

            })}
          >
            <option>select</option>
            <option value="private">Private</option>
            <option value="public">Public</option>
            <option value="non_profit">Non Profit</option>
            <option value="banijiya_new">New Banijiya</option>
            <option value="banijiya_existing">Existing Banijiya</option>
            <option value="gharelu_banijiya">Gharelu Banijiya</option>
            <option value="gharelu_industry">Ghaleru Industry</option>
            <option value="ward_prop_part">Ward Registration A</option>
            <option value="ward_prali">Ward Registration B</option>
            <option value="exim_code">Exim Code</option>
            <option value="pan_vat_gharelu_ward">Vat Registration A</option>
            <option value="pan_vat_prali">Vat Registration B</option>
            <option value="ssf">SSF Registration</option>
          </select>
        </div>

        
          {
            companyType === "ssf" &&
            <div className="border-b p-2 text-primary-blue border-primary-red">
              <label>SSF Form Type</label>
              <select
              className="outline-none ml-2 border-primary-red"
                {...register("ssf_form_type", { required: false })}>
                <option>Select</option>
                <option value="employer">Employer</option>
                <option value="employee">Employee</option>
              </select>
            </div>
          }
       

          {
            (companyType === "pan_vat_gharelu_ward" || companyType === "pan_vat_prali") &&
            <div className="border-b  text-primary-blue border-primary-red p-2">
              <label>Registration Nature</label>
              <select
              className="outline-none md:ml-2 border border-primary-red"

                {...register("registration_nature", { required: false })}>
                <option>Select</option>
                <option value="pan">Pan</option>
                <option value="pan_vat">PAN & VAT</option>
                <option value="pan_vat_excise">Pan Vat & Excise</option>
              </select>
            </div>
          }

        <div className="border-b md:border-r border-r-0 border-primary-red p-2 text-primary-blue">
          <label>Range Start</label>
          <input
            type="number"
            name="range_start"
            className="outline-none ml-2 "
            placeholder="00000"
            {...register("range_start", { required: false })}
          />
        </div>

        <div className="md:border-r border-b text-primary-blue border-primary-red  p-2 ">
          <label>Range End</label>
          <input
            type="number"
            name="range-end"
            placeholder="00000"
            className="outline-none ml-2 "

            {...register("range_end", { required: false })}
          />
        </div>

        <div className="p-2 border-r border-primary-red  text-primary-blue">
          <label>Amount</label>
          <input
            type="amount"
            placeholder="00000"
            name="amount"
            className="outline-none ml-2 "
            {...register("amount", { required: false })}
          />
        </div>
        </div>
        <button type="submit" className="bg-primary-red py-2 px-3 text-white rounded-md mt-5 float-right ">Submit</button>
      </form>
    </div>
  );
};

export default CreateCharge;
